
import React from 'react';

interface HeroProps {
  onBooking: () => void;
}

export default function Hero({ onBooking }: HeroProps) {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openWhatsApp = () => {
    // Guard against environments where `window` might be undefined (e.g., SSR)
    if (typeof window !== 'undefined' && window.open) {
      window.open('https://wa.me/message/FEG4Q7VZR4W2E1', '_blank');
    } else {
      console.error('Unable to open WhatsApp link: window is not defined.');
    }
  };

  return (
    <section id="hero" className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3e894668fb4de5de8de615f5ae229914.jpg"
          alt="Exquisite Nigerian interior design showcase"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative h-full flex items-end pb-24 px-6">
        <div className="max-w-7xl mx-auto w-full">
          <div className="max-w-3xl">
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center">
                <i className="ri-sparkling-2-fill text-4xl text-teal-400"></i>
              </div>
              <div className="w-12 h-12 flex items-center justify-center">
                <i className="ri-plant-line text-4xl text-teal-400"></i>
              </div>
              <div className="w-12 h-12 flex items-center justify-center">
                <i className="ri-lightbulb-flash-line text-4xl text-teal-400"></i>
              </div>
            </div>
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-serif font-bold text-white leading-tight mb-6">
              Transforming Nigerian Homes Into Living Art
            </h1>
            <p className="text-xl text-white/90 mb-8 max-w-2xl">
              Creating extraordinary interiors across Abuja and Lagos that blend African heritage with
              contemporary luxury
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <button
                onClick={scrollToContact}
                className="px-8 py-4 bg-teal-600 text-white rounded-full text-base font-medium hover:bg-teal-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Begin Your Transformation
              </button>
              <button
                onClick={onBooking}
                className="px-8 py-4 bg-white/15 backdrop-blur-sm border border-white/60 text-white rounded-full text-base font-medium hover:bg-white/25 transition-all hover:scale-105 whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-calendar-check-line text-lg"></i>
                </span>
                Book a Consultation
              </button>
              <button
                onClick={openWhatsApp}
                className="px-8 py-4 bg-green-600 text-white rounded-full text-base font-medium hover:bg-green-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-lg"></i>
                </span>
                Chat on WhatsApp
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
